module.exports = __webpack_public_path__ + "static/media/commercial-buildings--gray.36f2d8c7.svg";